const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://zfeltvw2b6.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://kty0q8loa7.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.uat.forwood.one'
  },
  configurationService: {
    URL: 'https://config.uat.forwood.one',
    WEBSOCKET: 'wss://30xjv1z799.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;